import { render, staticRenderFns } from "./insertInvoiceModal.vue?vue&type=template&id=124491be&scoped=true&"
import script from "./insertInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./insertInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./insertInvoiceModal.vue?vue&type=style&index=0&id=124491be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124491be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardTitle,VCol,VDataTable,VDialog,VImg,VRow,VSimpleCheckbox})
